<template>
  <div>
    <b-row>
      <b-col>
        <b-card class="mb-2">
          <b-row>
            <b-col cols="6" class="h3 mb-1">
              <span variant="primary">Configuracion de Docentes</span>
            </b-col>
            <b-col cols="3" class="mt-2">
              <b-form-checkbox v-model="showOnlyActive" name="check-button" switch>
                Mostrar solo Docentes Activos
              </b-form-checkbox>
            </b-col>
            <b-col cols="auto" class="ml-auto d-flex align-items-center">
              <b-button @click="newTeacher" variant="primary" class="m-1 d-flex align-items-center">
                <b-iconstack font-scale="1" class="ml-1" title="Agregar">
                  <b-icon stacked icon="plus" shift-h="-11"></b-icon>
                  <b-icon stacked icon="person-fill"></b-icon>
                </b-iconstack>
                <span class="ml-3">Agregar</span>
              </b-button>
            </b-col>
            <b-col cols="auto" class="d-flex align-items-center">
              <b-button @click="openCoordinatorModal" variant="outline-primary" class="m-1 d-flex align-items-center">
                <b-icon icon="feather" class="mr-2"></b-icon>
                Firmas
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table hover sticky-header no-border-collapse head-variant="light" striped style="min-height: 60vh;"
          :items="items" :fields="teacherFields" :busy="isBusy">
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Cargando...</strong>
            </div>
          </template>
          <template #cell(x_signature)="data">
            <b-img v-if="data.item.x_signature" thumbnail fluid :src="data.item.x_signature" alt="Image 1"
              style="height:50px"></b-img>
          </template>
          <template #cell(x_hiring_date)="data">
            <span v-if="data.item.x_hiring_date">{{ data.item.x_hiring_date }}</span>
          </template>
          <template #cell(x_name)="data">
            <b-avatar class='mr-2' :text="data.item.x_name[0]" size="2.5rem"
              :style="{ backgroundColor: data.item.x_color, color: data.item.x_color }"></b-avatar>
            <span style="font-size:1.3em">{{ data.item.x_name }}</span>
            <b-badge class='ml-2' v-if="!showOnlyActive && data.item.x_active" pill variant="success">active</b-badge>
          </template>

          <template #cell(acciones)="data">
            <b-icon @click='editTeacher(data.index)' v-if="!edit[data.index]" icon="pencil-square"
              class="h1 mb-1 mr-2 px-1 btn-like-icon" hover v-b-tooltip.hover title="Editar" variant="primary"></b-icon>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <!--   Modal de Agregar Docente   -->
    <new-teacher></new-teacher>
    <!--   Modal Configurar firmas y coordinacion   -->
    <b-modal id="config-supervisor-curso" title="Configurar coordinadores">
      <div v-if="loadingCourses" class="text-center my-3">
        <b-spinner class="align-middle mr-2"></b-spinner>
        <span>Cargando cursos...</span>
      </div>
      <div v-else>
        <b-table :items="courses" :fields="coordinatorFields" small head-variant="light" responsive="sm">
          <template #cell(name)="data">
            <div>{{ data.item.name }}</div>
            <div v-if="data.item.x_short_name" class="text-muted small">{{ data.item.x_short_name }}</div>
          </template>
          <template #cell(coordinator)="data">
            <b-form-select v-model="data.item.coordinatorSelection" :options="teacherSelectOptions"
              :disabled="loadingCourses"></b-form-select>
          </template>
        </b-table>
        <div v-if="!courses.length" class="text-center text-muted py-3">
          No hay cursos disponibles.
        </div>
      </div>

      <template #modal-footer="{ cancel }">
        <b-button variant="primary" @click="guardarConf()">
          Guardar
        </b-button>
        <b-button @click="cancel()">
          Cancelar
        </b-button>
      </template>
    </b-modal>
    <new-teacher @updateTeachers="updateLista()"></new-teacher>
    <edit-teacher :teacherToEdit="teacherToEdit" @updateTeachers="updateLista()"></edit-teacher>
    <!--   Modal Configurar firmas y coordinacion   -->
    <b-modal header-bg-variant="primary" size="m" header-text-variant="light" id="set-to-inactive"
      title="Docente Inactivo/a">
      <p class="pb-2"> No te preocupes! Los datos y clases asignadadas a <strong>{{ modalTeacher.display_name
          }}</strong> no
        van a
        eliminarse, solo se asignara un color blanco para el calendario y seguiras viendo sus datos historicos
      </p>
      <template #modal-footer="{ saveInactive, cancel }">
        <b-button variant="success" @click="saveInactive(modalTeacher.id)">
          Confirmar
        </b-button>
        <b-button @click="cancel()">
          Cancelar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { TeacherService } from '@/services/teacher.service'
import { CoursesService } from '@/services/courses.service'
import newTeacher from '../../components/pop-ups/newTeacher.vue'
import editTeacher from '../../components/pop-ups/editTeacher.vue'
import 'vue-swatches/dist/vue-swatches.css'

export default {
  name: 'ConfigTeachers',
  defaultSignatureImage: '../../assets/images/no_signature.png',
  components: { newTeacher, editTeacher },
  data () {
    return {
      showOnlyActive: true,
      uploadingSignature: false,
      uploadingIndex: null,
      signatureFile: null,
      signatureLoaded: false,
      swatches: [
        '', '#F64272', '#F493A7', '#B80087', '#F8524F',
        '#8b5aff', '#695E26', '#372772', '#D7331D',
        '#ffa51a', '#754306', '#55504E', '#202B31',
        '#5D4E46', '#8C7569', '#B09F96', '#5C5C5C',
        '#EB0E0A', '#257E3B', '#396A3A', '#AF4631',
        '#28777B', '#28657B', '#2B50AA'
      ],
      isBusy: true,
      edit: {},
      items: [],
      teacherFields: [
        { key: 'x_name', label: 'Nombre', sortable: true },
        { key: 'x_email', label: 'email' },
        { key: 'x_hiring_date', label: 'Contratacion', sortable: true },
        { key: 'x_signature', label: 'Firma' },
        { key: 'acciones', label: 'Acciones' }
      ],
      coordinatorFields: [
        { key: 'name', label: 'Curso', sortable: true },
        { key: 'coordinator', label: 'Coordinador/a' }
      ],
      courses: [],
      loadingCourses: false,
      modalTeacher: {},
      domain: { x_active: true },
      teacherToEdit: {}
    }
  },
  watch: {
    async showOnlyActive () {
      if (this.showOnlyActive) {
        this.domain.x_active = true
      } else {
        this.domain = {}
      }
      this.updateLista()
    }
  },
  computed: {
    teacherSelectOptions () {
      const options = [{ value: null, text: 'Sin coordinador/a' }]
      if (!Array.isArray(this.items) || !this.items.length) {
        return options
      }
      const addedIds = new Set()
      const activeTeachers = this.items.filter(teacher => {
        if (!teacher) {
          return false
        }
        if (teacher.x_active === undefined) {
          return true
        }
        return Boolean(teacher.x_active)
      })
      for (let i = 0; i < activeTeachers.length; i++) {
        const teacher = activeTeachers[i]
        const baseName = teacher.x_name || teacher.display_name || teacher.name || ('Docente ' + teacher.id)
        const jobTitle = ((teacher.x_job_title || teacher.role || '') + '').toLowerCase()
        const isCoordinator = jobTitle.indexOf('coordin') !== -1
        const label = isCoordinator ? baseName + ' - Coordinacion' : baseName
        options.push({ value: teacher.id, text: label })
        addedIds.add(teacher.id)
      }
      for (let i = 0; i < this.courses.length; i++) {
        const course = this.courses[i]
        const currentId = course.coordinatorSelection
        if (currentId && !addedIds.has(currentId)) {
          const fallbackName = Array.isArray(course.x_2nd_signature_id) ? course.x_2nd_signature_id[1] : ('Docente ' + currentId)
          options.push({ value: currentId, text: fallbackName + ' (inactivo)' })
          addedIds.add(currentId)
        }
      }
      return options
    }
  },

  async created () {
    this.isBusy = true
    await this.updateLista()
    await this.fetchCourses()
    this.isBusy = false
  },
  methods: {
    async fetchCourses () {
      this.loadingCourses = true
      try {
        const list = await CoursesService.list({})
        this.courses = list.map(course => {
          const current = Array.isArray(course.x_2nd_signature_id) ? course.x_2nd_signature_id[0] : null
          return {
            ...course,
            coordinatorSelection: current,
            initialCoordinatorId: current
          }
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingCourses = false
      }
    },
    async guardarConf () {
      this.loadingCourses = true
      try {
        const updates = []
        for (let i = 0; i < this.courses.length; i++) {
          const course = this.courses[i]
          if (course.coordinatorSelection !== course.initialCoordinatorId) {
            updates.push(
              CoursesService.update(course.id, {
                x_2nd_signature_id: course.coordinatorSelection || false
              })
            )
          }
        }
        if (updates.length) {
          await Promise.all(updates)
          await this.fetchCourses()
        }
        this.$bvModal.hide('config-supervisor-curso')
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingCourses = false
      }
    },
    openCoordinatorModal () {
      this.$bvModal.show('config-supervisor-curso')
      this.fetchCourses()
    },
    updateLista: async function () {
      this.isBusy = true
      try {
        this.items = await TeacherService.list(this.domain)
        this.isBusy = false
      } catch (error) {
        console.log(error)
      }
    },
    async newTeacher () {
      this.$bvModal.show('new-teacher')
    },
    async editTeacher (index) {
      this.teacherToEdit = this.items[index]
      this.$bvModal.show('edit-teacher')
    }
  }

}
</script>
